module.exports = __webpack_public_path__ + "media/images/favicon-1fbf31bf.ico";